import React from "react";
import Section from "./Section";
import { projects } from "../data/ProjectDetails";
import { profile } from "../data/profile";

const Projects = () => (
  <Section
    id="projects"
    title="Projects"
    subtitle="A selection of products and experiments I've shipped in Web3, AI, and full-stack."
  >
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
      {projects.map((project) => (
        <article
          key={project.title}
          className="flex flex-col rounded-2xl border border-line bg-surface p-6 transition-colors duration-100 hover:border-fg"
        >
          <div className="flex items-baseline justify-between gap-3">
            <h3 className="font-semibold">{project.title}</h3>
            {project.demoLink && (
              <span className="flex shrink-0 items-center gap-1.5 font-mono text-xs text-live">
                <span
                  className="h-1.5 w-1.5 rounded-full bg-live"
                  aria-hidden="true"
                />
                Live
              </span>
            )}
          </div>
          <p className="mt-1 text-sm text-muted">{project.description}</p>
          <p className="mt-3 font-mono text-xs leading-relaxed text-faint">
            {project.techStack}
          </p>
          <div className="mt-auto flex gap-2 pt-5">
            {project.demoLink && (
              <a
                href={project.demoLink}
                target="_blank"
                rel="noopener noreferrer"
                className="rounded-full border border-line px-4 py-1.5 text-sm font-medium transition-colors duration-100 hover:border-fg"
              >
                Visit ↗
              </a>
            )}
            {project.githubLink && (
              <a
                href={project.githubLink}
                target="_blank"
                rel="noopener noreferrer"
                className="rounded-full border border-line px-4 py-1.5 text-sm font-medium text-muted transition-colors duration-100 hover:border-fg hover:text-fg"
              >
                Code ↗
              </a>
            )}
          </div>
        </article>
      ))}
    </div>

    <div className="mt-10 flex justify-center">
      <a
        href={profile.socials.find((s) => s.label === "GitHub")?.url}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-block rounded-full border border-line px-6 py-3 text-sm font-semibold transition-colors duration-100 hover:border-fg"
      >
        See more on GitHub ↗
      </a>
    </div>
  </Section>
);

export default Projects;
